// extracted by mini-css-extract-plugin
export default {"container":"ModalUserEdit_container__nggfm","form":"ModalUserEdit_form__E030g","card":"ModalUserEdit_card__I3dKt"};